/* Product photo magnifier (mouse only): the photo follows the pointer at 2x, and a
   sharper file is swapped in on first use. Works for the ORKEN gallery stage and the
   Clan Wars single image. */
(function(){
  if(!matchMedia("(hover:hover) and (pointer:fine)").matches)return;
  const cur=f=>f.querySelector("img.main.on")||f.querySelector("img.main");
  const hi=u=>/[?&]width=\d+/.test(u)?u.replace(/([?&])width=\d+/,"$1width=2400"):u;
  function frameFor(t){
    const st=t.closest&&t.closest(".gal .stage");if(st)return st;
    const im=t.closest&&t.closest(".pp > img.main");
    if(im){const w=document.createElement("div");w.className="zoomwrap";im.replaceWith(w);w.append(im);return w}
    return t.closest&&t.closest(".zoomwrap");
  }
  const sharpen=img=>{if(!img||img.dataset.hi===img.currentSrc)return;const src=hi(img.currentSrc||img.src);if(src===img.currentSrc)return;
    const p=new Image();p.src=src;p.decode().then(()=>{if(!img.isConnected)return;img.removeAttribute("srcset");img.removeAttribute("sizes");img.src=src;img.dataset.hi=src}).catch(()=>{})};
  let frame=null;
  document.addEventListener("pointerover",e=>{
    if(e.pointerType!=="mouse")return;const f=frameFor(e.target);if(!f||f===frame)return;
    if(e.target.closest(".gnav,.gcount"))return;
    frame=f;f.classList.add("zooming");sharpen(cur(f));
  });
  document.addEventListener("pointermove",e=>{
    if(!frame)return;
    if(!frame.contains(e.target)||e.target.closest(".gnav,.gcount")){frame.classList.remove("zooming");frame=null;return}
    const r=frame.getBoundingClientRect();
    frame.style.setProperty("--zx",((e.clientX-r.left)/r.width*100).toFixed(2)+"%");
    frame.style.setProperty("--zy",((e.clientY-r.top)/r.height*100).toFixed(2)+"%");
    const on=cur(frame);if(on&&on.dataset.hi!==on.currentSrc)sharpen(on);
  },{passive:true});
  document.addEventListener("pointerout",e=>{if(frame&&!frame.contains(e.relatedTarget)){frame.classList.remove("zooming");frame=null}});
})();
